export default {
  toasts: {
    failed_to_save_changes: 'Salvataggio delle modifiche non riuscito.',
    successfully_saved: 'Salvato con successo.',
  },
  form: {
    has_multiple_locations: {
      label: 'Imposta posizioni diverse per la settimana',
    },
  },
  labels: {
    day_location: '{{day}} posizione {{index}}',
    selected_days: 'Giorni selezionati',
    orders_paused: 'Ordini in pausa',
    open_time: 'Orario di apertura',
    close_time: 'Orario di chiusura',
  },
  buttons: {
    save: 'Salva',
  },
};
